import React, { ReactNode } from 'react';

import styles from './styles.module.scss';

const Heading = ({ text }: { text: string }) => (
  <div className={styles.heading}>{text}</div>
);
const Item = ({ children }: { children: ReactNode }) => (
  <div className={styles.item}>{children}</div>
);
const Column = ({ children }: { children: ReactNode }) => (
  <div className={styles['column-border']}>{children}</div>
);

const LegendBar = (props: { showBup?: boolean }) => (
  <div className={styles.wrapper} data-testid="legend-bar">
    <Heading text="legend" />
    <Column>
      <Item>
        <Heading text="drug screen" />
      </Item>
      <Item>
        <span className={styles['clean-screen-pos']} />
        <span className={styles.label}>Not Completed</span>
      </Item>
      <Item>
        <span className={styles['clean-screen-neg']} />
        <span className={styles.label}>Completed</span>
      </Item>
    </Column>
    <Column>
      <Item>
        <Heading text="patient visit" />
      </Item>
      <Item>
        <span className={styles['appt-compliant']} />
        <span className={styles.label}>Seen</span>
      </Item>
    </Column>
    <Column>
      <Item>
        <Heading text="patient reported activity" />
      </Item>
      <Item>
        <span className={styles['patient-used']} />
        <span className={styles['label-patient']}>Substance Use</span>
        {props.showBup && (
          <span className={styles['bup-wrapper']}>
            <span className={styles['bup-nonuse']} />
            <span className={styles.label}>Buprenorphine Non-Use</span>
          </span>
        )}
      </Item>
      <Item>
        <span className={styles['patient-nonused']} />
        <span className={styles['label-patient']}>Substance Non-Use</span>
        {props.showBup ? (
          <span className={styles['bup-wrapper']}>
            <span className={styles['bup-used']} />
            <span className={styles.label}>Buprenorphine Use</span>
          </span>
        ) : null}
      </Item>
    </Column>
  </div>
);

export default LegendBar;
